import { VISIT_TYPES, VisitType } from "~/services";
import { StaffBookingFooter } from "../components/staff-booking-footer";
import { StepHeading } from "../components/step-heading";
import { VisitTypeButton } from "../components/visit-type-button";

const INACTIVE_VISIT_TYPES: VisitType[] = [
  VISIT_TYPES.NUTRITION_INITIAL_VISIT,
  VISIT_TYPES.NUTRITION_FOLLOW_UP_VISIT,
];

interface VisitTypeStepProps {
  hasEhrId: boolean;
  onSelect: (visitType: VisitType) => void;
  onCancel: () => void;
}

export const VisitTypeStep = ({
  hasEhrId,
  onSelect,
  onCancel,
}: VisitTypeStepProps) => {
  return (
    <div className="flex min-h-full flex-col gap-6">
      <StepHeading title="Book a visit" />
      <div className="flex flex-col gap-3">
        <p className="text-footer-text text-sm">Select a visit type</p>
        <div className="flex flex-col gap-3">
          {Object.values(VISIT_TYPES)
            .filter((visitType) => !INACTIVE_VISIT_TYPES.includes(visitType))
            .map((visitType) => (
              <VisitTypeButton
                disabled={visitType === VISIT_TYPES.FOLLOW_UP && !hasEhrId}
                key={visitType}
                visitType={visitType}
                onClick={() => onSelect(visitType)}
              />
            ))}
        </div>
      </div>
      <StaffBookingFooter onCancel={onCancel} />
    </div>
  );
};
